import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Auxiliary from 'components/Auxiliary';
import { buildMatchPath, RECORD_FIELD } from '@unicus/react-ui-kit';
import UserEdit from 'pages/shared/CurrentUserEdit';
import UpdatePassword from 'pages/shared/UpdatePassword';
import CurrentUserProfile from 'components/CurrentUserProfile';
import CustomScrollbars from 'components/CustomScrollbars';
import SidebarLogo from './SidebarLogo';
import SidebarContentRoute from './SidebarContentRoute';

import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
  APP_ADMIN
} from '../../constants/themeSettings';

class SidebarContent extends Component {
  getNoHeaderClass = (navStyle) => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return 'gx-no-header-notifications';
    }
    return '';
  };

  getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return 'gx-no-header-submenu-popup';
    }
    return '';
  };

  render() {
    const {
      themeType,
      navStyle,
      pathname,
      routes,
      match,
      currentApp,
      resourceUsers,
      readOnly
    } = this.props;

    let selectedKeys = pathname.substr(1);
    if (selectedKeys === '') {
      selectedKeys = 'index';
    }

    return (
      <Auxiliary>
        <SidebarLogo />

        {resourceUsers && resourceUsers.editingPassword && (
          <UpdatePassword updatePassword={resourceUsers.editingPassword} />
        )}

        <div className="gx-sidebar-content">
          <SidebarContentRoute
            routes={routes}
            pathname={pathname}
            match={match}
            readOnly={readOnly}
          />
        </div>
      </Auxiliary>
    );
  }
}

SidebarContent.propTypes = {};
const mapStateToProps = ({ settings, resources = {} }) => {
  const { navStyle, themeType, locale, pathname, currentApp } = settings;
  const { users = {} } = resources;
  const { editing: editingUser, [RECORD_FIELD]: resourceUsers = {} } = users;
  return {
    navStyle,
    themeType,
    locale,
    pathname,
    currentApp,
    editingUser,
    resourceUsers
  };
};
export default connect(mapStateToProps)(SidebarContent);
